module.exports = __webpack_public_path__ + "static/media/XIRS7481.c01fbcbe.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/XIRS7481.JPG
// module id = 376
// module chunks = 0